// Copyright (C) 2021 Bystronic Laser AG

import axios from 'axios';
import { BaseUrl } from '@/models/constants';
import { StandardAlert } from '@/models/standardAlert';
import { responseHandler } from './response.handler';
import {
  StandardAlertCreationData,
  StandardAlertEditionData,
} from '@/components/alerts/model';

class StandardAlertsService {
  /** Returns a list of all standard alerts. */
  getAll(): Promise<StandardAlert[]> {
    return axios
      .get<StandardAlert[]>(`${BaseUrl}/standard-alerts`)
      .then((response) => responseHandler.handleDates(response.data));
  }

  create(standardAlert: StandardAlertCreationData): Promise<void> {
    return axios.post(`${BaseUrl}/standard-alerts`, standardAlert);
  }

  async update(standardAlertData: StandardAlertEditionData): Promise<void> {
    return axios.put(`${BaseUrl}/standard-alerts`, standardAlertData);
  }
}

export const standardAlertsService = new StandardAlertsService();
